














































	import Component, { mixins } from "vue-class-component";
	import Project from "@/lib/Project";
	import { Prop } from "vue-property-decorator";
	import ProjectHelper from "@/mixins/ProjectHelper";
	import { colorList } from "@/constants/colorList";
import Utils from "@/lib/Utils";

	@Component
	export default class AddProjectDialog extends mixins(ProjectHelper) {

		@Prop({ type: Boolean, required: true })
		visible! : boolean;

		@Prop({ type: String })
		projectId! : string;

		projectName = "";
		projectColor = "";

		focused = false;

		colorList = colorList;

		dateStart = "";
		dateEnd = "";

		created() : void {
			if (this.projectId === undefined) {
				this.projectName = "";
				this.projectColor = colorList[0].base;
			} else {
				const project = (this.$store.state.projectList as Project[]).find(p => p.id === this.projectId);
				if (project === undefined) {
					throw new Error(`can't find project of id: ${this.projectId}, please check your prop value`);
				} else {
					this.projectName = project.name;
					this.projectColor = project.color;
					this.dateStart = project.dateStart;
					this.dateEnd = project.dateEnd;
				}
			}
		}

		submitNewProject() : void {
			const project = new Project();

			// if (this.projectId === undefined) {
			// 	project.id = createId("project").toString()
			// } else {
			// 	project.id = this.projectId;
			// }
			project.id = this.projectId;
			project.color = this.projectColor;
			project.name = this.projectName;
			if (this.dateStart) {
				project.dateStart = this.dateStart;
			}
			if (this.dateEnd) {
				project.dateEnd = this.dateEnd;
			}
			this.$store.commit("modifyProject", project);

			this.$emit('update:visible', false);
		}

		selectColor(color : string) : void {
			this.projectColor = color;
		}

		deleteProject() : void {
			this.$store.commit('deleteProject', this.projectId);
			this.$message({
				message: '删除成功',
				type: 'success'
			});
			this.$emit('update:visible', false);
		}

		close() : void {
			this.$emit('update:visible', false);
		}

	}
